
// admin panel

// export const url = process.env.REACT_APP_API_URL;
// export const socket_url = process.env.REACT_APP_SOCKET_URL;

 
const isDevelopment = process.env.NODE_ENV === "development";
export const url = process.env.REACT_APP_API_URL ||
  (isDevelopment ? "http://localhost:4000/v1" : "https://myuaestartup.com/api/v1");
export const socket_url = process.env.REACT_APP_SOCKET_URL ||
  (isDevelopment ? "http://localhost:5000" : "https://myuaestartup.com");


// export const url = "http://localhost:4000/v1";
// export const socket_url = "http://localhost:5000";



